export const CONTACT = {
  phone: "03365983158",
  phoneHref: "tel:+913365983158",
  email: "info@skyroutefreights.com",
  footerAddress: "SkyRoute Freights Pvt Ltd, Kolkata, West Bengal, India",
  officeCity: "Kolkata",
  officeAddress: "SkyRoute Freights Pvt Ltd, Kolkata, West Bengal, India",
  hours: "Mon–Sat: 9:00 AM – 7:00 PM",
};

export const NAV_LINKS = [
  { to: "/", label: "Home" },
  { to: "/services", label: "Services" },
  { to: "/about", label: "About" },
  { to: "/tracking", label: "Tracking" },
  { to: "/contact", label: "Contact" },
];

export const IMAGES = {
  air: "https://images.unsplash.com/photo-1587019158091-1a103c5dd17f?auto=format&fit=crop&w=1600&q=80",
  sea: "https://images.unsplash.com/photo-1578575437130-527eed3abbec?auto=format&fit=crop&w=1600&q=80",
  customs: "https://images.unsplash.com/photo-1601897690942-bcacbad33e55?auto=format&fit=crop&w=1600&q=80",
  land: "https://images.unsplash.com/photo-1592805144716-feeccccef5ac?auto=format&fit=crop&w=1600&q=80",
  courier: "https://images.unsplash.com/photo-1580674285054-bed31e145f59?auto=format&fit=crop&w=1600&q=80",
  ticketing: "https://images.unsplash.com/photo-1586441133374-ed1cb4007a47?auto=format&fit=crop&w=1600&q=80",
  port: "https://images.unsplash.com/photo-1552207802-77bcb0d13122?auto=format&fit=crop&w=1600&q=80",
};

export const HERO = {
  badge: "GLOBAL FREIGHT FORWARDING",
  titleA: "Your cargo. Our route.",
  titleB: "Your success.",
  sub: "India's trusted global freight forwarding partner — connecting your business to the world with speed, precision, and care.",
};

export const STATS = [
  { value: 500, suffix: "+", label: "Destinations" },
  { value: 15, suffix: "+", label: "Years Experience" },
  { value: 10000, suffix: "+", label: "Shipments Handled" },
  { value: 24, suffix: "/7", label: "Support" },
];

export const SERVICES = [
  {
    id: "air-freight",
    num: "01",
    icon: "plane",
    title: "Air Freight",
    short: "Fast, reliable air cargo solutions connecting you to 500+ global destinations.",
    eyebrow: "SPEED WITHOUT COMPROMISE",
    blurb:
      "When time is critical, our air freight solutions deliver. We partner with leading airlines to offer competitive rates and guaranteed space on flights to over 500 destinations worldwide. Whether it's urgent samples, high-value goods, or time-sensitive shipments, our air cargo team ensures your consignment reaches its destination safely and on schedule.",
    points: [
      "Express and standard air cargo options",
      "Door-to-door and airport-to-airport services",
      "Real-time flight tracking and status updates",
      "Handling of perishables, pharmaceuticals, and high-value cargo",
      "Consolidated and charter flight options",
      "Full documentation and customs support",
    ],
    image: IMAGES.air,
  },
  {
    id: "sea-freight",
    num: "02",
    icon: "ship",
    title: "Sea Freight",
    short: "Cost-effective ocean freight for FCL and LCL shipments worldwide.",
    eyebrow: "COST-EFFECTIVE OCEAN LOGISTICS",
    blurb:
      "Our sea freight services offer the most economical solution for large-volume shipments. We handle Full Container Load (FCL) and Less than Container Load (LCL) shipments across all major global trade lanes. With strong carrier relationships and deep port expertise, we ensure your cargo moves smoothly from origin to destination.",
    points: [
      "FCL and LCL shipments to all major ports",
      "Competitive ocean freight rates",
      "Port-to-port and door-to-door delivery",
      "Reefer and out-of-gauge cargo handling",
      "Hazardous goods (DG) cargo expertise",
      "Weekly sailings on key trade lanes",
    ],
    image: IMAGES.sea,
  },
  {
    id: "customs-clearance",
    num: "03",
    icon: "shield",
    title: "Customs Clearance",
    short: "Hassle-free customs documentation and clearance by certified experts.",
    eyebrow: "SMOOTH BORDERS, ZERO DELAYS",
    blurb:
      "Navigating customs regulations can be complex and time-consuming. Our certified customs brokers handle all import and export documentation, duties, and compliance requirements on your behalf. We ensure your shipments clear customs quickly and without complications, keeping your supply chain moving.",
    points: [
      "Import and export customs documentation",
      "HS code classification and duty calculation",
      "Liaison with customs authorities",
      "Compliance with DGFT and EXIM policies",
      "Drawback and duty exemption processing",
      "Post-clearance audit support",
    ],
    image: IMAGES.customs,
  },
  {
    id: "land-transport",
    num: "04",
    icon: "truck",
    title: "Land Transport",
    short: "End-to-end road freight across India and cross-border land routes.",
    eyebrow: "RELIABLE ROAD FREIGHT ACROSS INDIA",
    blurb:
      "Our land transport network covers every corner of India and extends to cross-border routes in South Asia. With a fleet of modern vehicles and a trusted network of transport partners, we offer flexible road freight solutions for full truckload (FTL) and less-than-truckload (LTL) shipments, ensuring safe and timely delivery.",
    points: [
      "Full Truckload (FTL) and Part Load (LTL) options",
      "Pan-India coverage including remote locations",
      "GPS-tracked fleet for real-time visibility",
      "Temperature-controlled transport available",
      "Cross-border road freight to Nepal, Bangladesh, Bhutan",
      "First and last-mile delivery solutions",
    ],
    image: IMAGES.land,
  },
  {
    id: "international-courier",
    num: "05",
    icon: "box",
    title: "International Courier",
    short: "Express door-to-door courier delivery to over 200 countries.",
    eyebrow: "EXPRESS DELIVERY WORLDWIDE",
    blurb:
      "Our international courier service provides fast, reliable, and trackable delivery of documents and parcels to over 200 countries. We work with the world's leading courier networks to offer competitive transit times and end-to-end visibility, making us the preferred choice for businesses and individuals alike.",
    points: [
      "Express delivery to 200+ countries",
      "Document and parcel shipments",
      "Online tracking from pickup to delivery",
      "Customs clearance included",
      "Competitive volumetric weight pricing",
      "Pickup from your doorstep",
    ],
    image: IMAGES.courier,
  },
  {
    id: "ticketing",
    num: "06",
    icon: "ticket",
    title: "Domestic & International Ticketing",
    short: "Domestic and international air ticketing for business and leisure travel.",
    eyebrow: "TRAVEL SOLUTIONS FOR BUSINESS & LEISURE",
    blurb:
      "Beyond freight, we offer comprehensive air ticketing services for both domestic and international travel. Our experienced travel desk secures the best fares across all major airlines, handles group bookings, and manages itinerary changes — ensuring smooth travel for your team and clients.",
    points: [
      "Domestic air tickets across all Indian carriers",
      "International air tickets on all major airlines",
      "Group booking and corporate travel management",
      "Visa assistance and travel documentation",
      "Hotel and ground transport coordination",
      "24/7 travel support for emergencies",
    ],
    image: IMAGES.ticketing,
  },
];

export const HOME_SERVICE_CARDS = [
  { ...SERVICES[0], title: "Air Freight" },
  { ...SERVICES[1], title: "Sea Freight" },
  { ...SERVICES[2], title: "Custom Clearance" },
  { ...SERVICES[3], title: "Land Transport" },
  { ...SERVICES[4], title: "International Courier" },
  { ...SERVICES[5], title: "Ticketing Services" },
];

export const FOOTER_SERVICE_LINKS = [
  "Air Freight",
  "Sea Freight",
  "Custom Clearance",
  "Land Transport",
  "International Courier",
  "Ticketing Services",
];

export const WHY_US = [
  {
    icon: "clock",
    title: "On-Time Delivery",
    text: "We guarantee timely delivery with real-time tracking and proactive updates at every step.",
  },
  {
    icon: "globe",
    title: "End-to-End Solutions",
    text: "From pickup to final delivery, we handle every aspect of your supply chain seamlessly.",
  },
  {
    icon: "shield",
    title: "Customs Expertise",
    text: "Our certified customs brokers ensure smooth clearance with zero compliance headaches.",
  },
  {
    icon: "network",
    title: "Global Network",
    text: "Partnerships with 200+ agents worldwide give your cargo access to every corner of the globe.",
  },
];

export const STORY = [
  "SkyRoute Freights was founded with a single conviction: that businesses deserve a freight partner they can truly rely on. What began as a small customs clearance firm in Mumbai has grown into one of India's most trusted full-service freight forwarding companies, with offices across the country and a global network spanning over 200 destinations.",
  "Over the years, we have built deep expertise across every mode of transport — air, sea, and land — and developed strong relationships with airlines, shipping lines, and customs authorities worldwide. Our team of seasoned professionals brings decades of combined experience to every shipment, no matter how complex.",
  "Today, SkyRoute Freights serves hundreds of businesses across industries — from manufacturing and pharmaceuticals to retail and e-commerce — delivering end-to-end logistics solutions that keep supply chains moving and businesses growing.",
];

export const ABOUT_STATS = [
  { value: 500, suffix: "+", title: "Global Destinations", text: "Our network reaches over 500 ports, airports, and inland destinations across 6 continents." },
  { value: 20, suffix: "+", title: "Years of Experience", text: "Two decades of navigating complex trade lanes, regulations, and logistics challenges." },
  { value: 10000, suffix: "+", title: "Shipments Delivered", text: "A proven track record of successful deliveries across air, sea, and land freight." },
  { value: 24, suffix: "/7", title: "Expert Support", text: "Round-the-clock assistance from our dedicated operations and customer service teams." },
];

export const MISSION =
  "To be India's most reliable freight forwarding partner — delivering seamless, transparent, and cost-effective logistics solutions that empower businesses to trade without borders.";

export const VALUES = [
  { icon: "shield", title: "Reliability", text: "We treat every shipment as a commitment. Our clients trust us because we deliver — on time, every time, without excuses." },
  { icon: "eye", title: "Transparency", text: "No hidden fees, no surprises. We keep our clients informed at every step with clear communication and real-time updates." },
  { icon: "graduation", title: "Expertise", text: "Our team brings deep knowledge of international trade regulations, customs procedures, and global logistics to every engagement." },
  { icon: "handshake", title: "Client Focus", text: "We listen first. Every solution we offer is tailored to the specific needs, timelines, and budgets of our clients." },
  { icon: "heart", title: "Integrity", text: "We operate with honesty and accountability — in our pricing, our processes, and our partnerships." },
  { icon: "bulb", title: "Innovation", text: "We continuously invest in technology and processes to make freight forwarding faster, smarter, and more efficient." },
];

export const SERVICE_OPTIONS = [
  "Air Freight",
  "Sea Freight",
  "Custom Clearance",
  "Land Transport",
  "International Courier",
  "Domestic Ticketing",
  "International Ticketing",
  "Other",
];
